module.exports = __webpack_public_path__ + "static/media/NunitoSans-Regular.ea597fcf.eot";